<component-loader-spinner [isLoading]="loading"></component-loader-spinner>

    <div class="alert alert-warning text-center" *ngIf="!baseCampaign.account.isCampaignCreation">
        Geographic targeting must comply with IP usage guidelines set by Learfield.
    </div>
    <div *ngIf="!!errorMessage" class="alert alert-danger">
        <b>{{ errorMessage}}</b>
    </div>

    <p-tabView [ngClass]="loading == true? 'content-disabled':''">
        <p-tabPanel header="Select Geo">
            <div class="mb-2 mt-2 row align-items-center" *ngIf="this.baseCampaign.campaignType == enumAccountType.FAN365 || this.baseCampaign.campaignType == enumAccountType.OAS">
    
                <div class="col-md-2">
                    <p-checkbox [(ngModel)]="isStateChecked" [disabled]="disabled" (onChange)="disableOther($event)" binary="true" inputId="none"></p-checkbox>
                </div>
                <div class="col-md-10 font-weight-bold">
                    Targeting the state of {{states[0]?.label}}
                </div>
            </div>

            <div class="mb-2 row align-items-center" *ngIf="this.baseCampaign.account.isCampaignCreation || this.baseCampaign.campaignType == enumAccountType.Social">
                <div class="col-md-2 font-weight-bold">
                    State
                </div>
                <div class="col-md-10">
                    <p-dropdown *ngIf="this.baseCampaign.campaignType != enumAccountType.Social" [placeholder]="'Choose'"  autoWidth="false" filter="true" (onChange)="detectChanges()" [style]="{'width':'100%'}" [(ngModel)]="selectedStates" [disabled]="isStateChecked || disabled" [options]="states" [virtualScroll]="true" [itemSize]="31"></p-dropdown>

                    <p-multiSelect *ngIf="this.baseCampaign.campaignType == enumAccountType.Social" [placeholder]="'Choose'" (onChange)="onMultiSelectChange('states', $event)" appendTo="body" panelStyleClass="geo-social-multiselect-panel" [options]="filteredStates" [disabled]="isStateChecked || disabled" [(ngModel)]="selectedStates" [virtualScroll]="true" [itemSize]="31">
                        <ng-template pTemplate="selectedItems">
                            <ng-container *ngIf="selectedStates?.length; else emptyState">
                                {{ getSelectedLabels(states, selectedStates, 'states') }}
                            </ng-container>

                            <ng-template #emptyState>
                                Choose
                            </ng-template>
                        </ng-template>
                        
                        <ng-template pTemplate="header">
                            <div class="state-filter-tabs">
                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.states === 'all'"
                                    (click)="setMultiSelectFilter('states', 'all'); $event.stopPropagation()">
                                    All ({{ states?.length || 0 }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.states === 'selected'"
                                    (click)="setMultiSelectFilter('states', 'selected'); $event.stopPropagation()">
                                    Selected ({{ getSelectedCount(selectedStates) }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.states === 'notSelected'"
                                    (click)="setMultiSelectFilter('states', 'notSelected'); $event.stopPropagation()">
                                    Not selected ({{ getNotSelectedCount(states, selectedStates) }})
                                </button>

                            </div>

                        </ng-template>
                </p-multiSelect>  
                </div>
            </div>

            <div class="mb-2 row align-items-center" *ngIf="!(this.baseCampaign.campaignType == enumAccountType.OAS && this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.defaultGeo == true)">
                <div class="col-md-2 font-weight-bold">
                    City
                </div>
                <div class="col-md-10">
                    <p-multiSelect *ngIf="this.baseCampaign.campaignType != enumAccountType.Social" [placeholder]="'Choose'" [options]="cities" [disabled]='isStateChecked || disabled || (this.baseCampaign.campaignType == enumAccountType.FAN365 ? selectedDmas.length && !selectedCities.length : false)' appendTo="body" (onChange)="detectChanges()" [(ngModel)]="selectedCities" [virtualScroll]="yes" itemSize="30" selectedItemsLabel="{0} items selected" panelStyleClass="geo-social-multiselect-panel"></p-multiSelect>

                    <p-multiSelect *ngIf="this.baseCampaign.campaignType == enumAccountType.Social" [placeholder]="'Choose'" [options]="filteredCities" [disabled]='isStateChecked || disabled' (onChange)="onMultiSelectChange('cities', $event)" appendTo="body" panelStyleClass="geo-social-multiselect-panel" [(ngModel)]="selectedCities" [virtualScroll]="yes" itemSize="30">
                        <ng-template pTemplate="selectedItems">
                            <ng-container *ngIf="selectedCities?.length; else emptyState">
                                {{ getSelectedLabels(cities, selectedCities,'cities') }}
                            </ng-container>

                            <ng-template #emptyState>
                                Choose
                            </ng-template>
                        </ng-template>
                        
                        <ng-template pTemplate="header">

                            <div class="state-filter-tabs">
                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.cities === 'all'"
                                    (click)="setMultiSelectFilter('cities', 'all'); $event.stopPropagation()">
                                    All ({{ cities?.length || 0 }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.cities === 'selected'"
                                    (click)="setMultiSelectFilter('cities', 'selected'); $event.stopPropagation()">
                                    Selected ({{ getSelectedCount(selectedCities) }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.cities === 'notSelected'"
                                    (click)="setMultiSelectFilter('cities', 'notSelected'); $event.stopPropagation()">
                                    Not selected ({{ getNotSelectedCount(cities, selectedCities) }})
                                </button>
                            </div>

                        </ng-template>
                    </p-multiSelect>

                
                </div>
            </div>

            <div class="mb-2 row align-items-center" *ngIf="!(this.baseCampaign.campaignType == enumAccountType.OAS && this.baseCampaign.campaignInventoryItems[0]?.inventoryItemOAS?.defaultGeo == true)">
                <div class="col-md-2 font-weight-bold">
                    DMA
                </div>
                <div class="col-md-10">
                    <p-dropdown [placeholder]="'Choose'" (onChange)="detectChanges()" autoWidth="false" filter="true" [style]="{'width':'100%'}"  *ngIf="this.baseCampaign.account.isCampaignCreation" [(ngModel)]="selectedDmas" [disabled]="isStateChecked || disabled || ((this.baseCampaign.campaignType == enumAccountType.FAN365) ? selectedCities.length && !selectedDmas.length : false)" [options]="dmas" [virtualScroll]="true" [itemSize]="31"></p-dropdown>

                    <p-multiSelect *ngIf="(this.baseCampaign.campaignType == enumAccountType.FAN365 || this.baseCampaign.campaignType == enumAccountType.OAS) && this.baseCampaign.campaignType != enumAccountType.Social" [placeholder]="'Choose'" [options]="dmas" appendTo="body" [disabled]='isStateChecked || disabled || (this.baseCampaign.campaignType == enumAccountType.FAN365 ? selectedCities.length && !selectedDmas.length : false)' [(ngModel)]="selectedDmas"  (onChange)="detectChanges()" [virtualScroll]="yes" itemSize="30" panelStyleClass="geo-social-multiselect-panel"></p-multiSelect>
                
                    <p-multiSelect *ngIf="this.baseCampaign.campaignType == enumAccountType.Social" [placeholder]="'Choose'" [options]="filteredDmas" [disabled]='isStateChecked || disabled' [(ngModel)]="selectedDmas"  (onChange)="onMultiSelectChange('dmas', $event)" appendTo="body" panelStyleClass="geo-social-multiselect-panel" [virtualScroll]="yes" itemSize="30">
                        <ng-template pTemplate="selectedItems">
                            <ng-container *ngIf="selectedDmas?.length; else emptyState">
                                {{ getSelectedLabels(dmas, selectedDmas,'dmas') }}
                            </ng-container>

                            <ng-template #emptyState>
                                Choose
                            </ng-template>
                        </ng-template>
                        
                        <ng-template pTemplate="header">

                            <div class="state-filter-tabs">

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.dmas === 'all'"
                                    (click)="setMultiSelectFilter('dmas', 'all'); $event.stopPropagation()">
                                    All ({{ dmas?.length || 0 }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.dmas === 'selected'"
                                    (click)="setMultiSelectFilter('dmas', 'selected'); $event.stopPropagation()">
                                    Selected ({{ getSelectedCount(selectedDmas) }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.dmas === 'notSelected'"
                                    (click)="setMultiSelectFilter('dmas', 'notSelected'); $event.stopPropagation()">
                                    Not selected ({{ getNotSelectedCount(dmas, selectedDmas) }})
                                </button>

                            </div>

                        </ng-template>
                    </p-multiSelect>
                    
                </div>
            </div>
    
            <div class="mb-2 row align-items-center" *ngIf="customZip && (this.baseCampaign.campaignType == enumAccountType.FAN365 || this.baseCampaign.campaignType == enumAccountType.OAS || this.baseCampaign.campaignType == enumAccountType.Social)">
                <div class="col-md-2 font-weight-bold">
                    Zip Code
                </div>
                <div class="col-md-10">
                    <p-multiSelect *ngIf="this.baseCampaign.campaignType != enumAccountType.Social" [options]="zipCodes" [disabled]='isStateChecked || disabled' [(ngModel)]="selectedZipCodes" [virtualScroll]="yes" itemSize="30" (onChange)="detectChanges()" selectedItemsLabel="{0} items selected" appendTo="body" panelStyleClass="geo-social-multiselect-panel"></p-multiSelect>
                    <p-multiSelect *ngIf="this.baseCampaign.campaignType == enumAccountType.Social" [placeholder]="'Choose'" [options]="filteredZipCodes" [disabled]='isStateChecked || disabled' [(ngModel)]="selectedZipCodes" [virtualScroll]="yes" itemSize="30" (onChange)="onMultiSelectChange('zipCodes', $event)" appendTo="body" panelStyleClass="geo-social-multiselect-panel">
                        <ng-template pTemplate="selectedItems">
                            <ng-container *ngIf="selectedZipCodes?.length; else emptyState">
                                {{ getSelectedLabels(zipCodes, selectedZipCodes,'zipCodes') }}
                            </ng-container>

                            <ng-template #emptyState>
                                Choose
                            </ng-template>
                        </ng-template>
                        
                        <ng-template pTemplate="header">

                            <div class="state-filter-tabs">

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.zipCodes === 'all'"
                                    (click)="setMultiSelectFilter('zipCodes', 'all'); $event.stopPropagation()">
                                    All ({{ zipCodes?.length || 0 }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.zipCodes === 'selected'"
                                    (click)="setMultiSelectFilter('zipCodes', 'selected'); $event.stopPropagation()">
                                    Selected ({{ getSelectedCount(selectedZipCodes) }})
                                </button>

                                <button
                                    type="button"
                                    [class.active]="multiSelectFilters.zipCodes === 'notSelected'"
                                    (click)="setMultiSelectFilter('zipCodes', 'notSelected'); $event.stopPropagation()">
                                    Not selected ({{ getNotSelectedCount(zipCodes, selectedZipCodes) }})
                                </button>

                            </div>

                        </ng-template>

                    </p-multiSelect>
                    
                </div>
            </div>
        </p-tabPanel>
        
        <p-tabPanel header="Bulk Upload Zips" *ngIf="(this.baseCampaign.campaignType == enumAccountType.FAN365 || this.baseCampaign.campaignType == enumAccountType.OAS) && customZip" [disabled]="!customZip">
            <div class="mb-2 mt-2">
                <div class="mb-1 font-weight-bold">Type or paste ZIP codes into the text box bellow (comma delimited)</div>
                <textarea rows="3" [(ngModel)]="pastedZipcodes" (ngModelChange)="onTextareaChanged($event)" [disabled]="disabled"></textarea>
            </div>
    
            <div>
                <div class="mb-1 font-weight-bold">Or</div>
                <rc-filedrop [files]="files" [allowedExtensions]="allowedFileExtensions" (onFilesDropped)="parseFile($event)" [disabled]="disabled"></rc-filedrop>
            </div>
        </p-tabPanel>
    
    </p-tabView>
